import React from 'react'

// components
import { Button, Grid } from '@mui/material'

export default function generate({
  t,
  classes,
  items,
  onModifyControlLocation,
  onDeleteControlLocation,
}) {
  return [
    {
      name: 'name',
      label: t('control-locations-list.control-location-table-header'),
    },
    {
      name: 'constructors',
      label: t('control-locations-list.constructors-table-header'),
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) => {
          const item = items[tableMeta.rowIndex]
          if (!item || !item.constructors) return ''
          return item.constructors
            .map((c) => c.title)
            .map((value, i) => (
              <Grid item key={item.constructors[i].id}>
                <span>{value}</span>
              </Grid>
            ))
        },
      },
    },
    {
      name: 'modify',
      label: ' ',
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) => (
          <Button
            className={classes.linkButton}
            variant="text"
            onClick={() => onModifyControlLocation(tableMeta.rowIndex)}
            color="primary"
          >
            {t('common.modify')}
          </Button>
        ),
      },
    },
    {
      name: 'delete',
      label: ' ',
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) => (
          <Button
            className={classes.linkButton}
            variant="text"
            onClick={() => onDeleteControlLocation(tableMeta.rowIndex)}
            color="primary"
          >
            {t('common.delete')}
          </Button>
        ),
      },
    },
  ]
}
